var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0.000976562C224.686 0.000976562 194.689 5.63398 166.957 15.924L155.826 256.001L166.956 496.078C194.689 506.369 224.686 512.001 256 512.001C287.314 512.001 317.311 506.369 345.043 496.078L356.174 256.001L345.044 15.924C317.311 5.63398 287.314 0.000976563 256 0.000976563V0.000976562Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256.001C512 145.93 442.528 52.0951 345.043 15.9241V496.079C442.528 459.907 512 366.072 512 256.001V256.001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957 496.078V15.9241C69.472 52.0951 0 145.93 0 256.001C0 366.072 69.472 459.907 166.957 496.078Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChad);
export default __webpack_public_path__ + "static/media/chad.fe1a4643e0cdc0367b51d86929c115ac.svg";
export { ForwardRef as ReactComponent };